import { render, staticRenderFns } from "./_tabSportsmansCards.vue?vue&type=template&id=1d957f4e&scoped=true&"
import script from "./_tabSportsmansCards.vue?vue&type=script&lang=js&"
export * from "./_tabSportsmansCards.vue?vue&type=script&lang=js&"
import style0 from "./_tabSportsmansCards.vue?vue&type=style&index=0&id=1d957f4e&prod&scoped=true&lang=css&"
import style1 from "./_tabSportsmansCards.vue?vue&type=style&index=1&id=1d957f4e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d957f4e",
  null
  
)

export default component.exports